import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { toast } from '@/components/ui/use-toast';

/**
 * Opens the PERSONAL one-to-one conversation with a guild member.
 *
 * Deliberately not the guild-scoped conversation the row's own Message button
 * opens: the person menu is the same menu the chat arche shows, and "Message"
 * there has always meant the ordinary DM. Making it mean something else inside
 * a guild would be the surprise.
 *
 * Lives here rather than inline because both the guild detail page and the
 * guild management page need it, and two copies of a navigation-plus-toast
 * handler is how the two pages start behaving differently.
 */
export function useOpenPersonalDm(): (userId: string) => Promise<void> {
  const navigate = useNavigate();

  return useCallback(
    async (userId: string) => {
      try {
        const { channel } = await api.getOrCreateDirectChannel(userId, { isUserId: true });
        navigate(`/a/arche_chat/channel/${channel.channelId}`);
      } catch (err) {
        toast({
          title: 'Could not open that conversation',
          description: err instanceof Error ? err.message : 'Please try again.',
          variant: 'destructive',
        });
      }
    },
    [navigate],
  );
}
